(function () {
    'use strict';
    $(document).ready(function () {

        var CookiesManager = {
            EXPIRES_KEY: "expires",
            PATH_KEY: "path",
            DOMAIN_KEY: "domain",
            SESSION_EXPIRES_VALUE: "session",
            getExpirationDate: function (days) {
                var now = new Date;
                now.setDate(now.getDate() + ("" === days ? 7 : days));
                return now.toUTCString()
            },
            getExpiresValue: function (a, b) {
                return (a ? CookiesManager.SESSION_EXPIRES_VALUE : CookiesManager.getExpirationDate(b)) +
                    ";"
            },
            getCookieValue: function (cookie) {
                cookie += "\x3d";
                for (var cookieArray = document.cookie.split(";"), i = 0; i < cookieArray.length; i++) {

                    for (var value = cookieArray[i]; " " === value.charAt(0);)
                        value = value.substring(1);

                    if (0 === value.indexOf(cookie))
                        return value.substring(cookie.length, value.length)
                }
                return ""
            },
            setCookieValue: function (name, value) {
                var expires = 7, path = "/", domain = "esg.santander.pl";

                if(location.hostname.match('lkwadrat3')){
                    domain = 'raport-santander2018.lkwadrat3.nazwa.pl';
                }else if(location.hostname.match('uxeria')){
                    domain = 'raport.vps.uxeria.com';
                }

                document.cookie = name + "=" + escape(value) + ";expires=" + expires + ";path=" + path + ";domain=" + domain + ";";
            }
        };

        var cookiePolicyContainer = $(".uc-cookies-policy"),
            acceptCookies = cookiePolicyContainer.find(".js-cookies-policy.accept");

        switch (CookiesManager.getCookieValue("cookiesPolicyAccepted")) {
            case"":
                cookiePolicyContainer.addClass("is--active");
                break;
            case"isAccepted":
                cookiePolicyContainer.addClass("is--accepted");
                $(".cookies-script").attr('type', "text/javascript")
                break;
            case"isNotAccepted":
                cookiePolicyContainer.addClass("is--notaccepted");
                break;
            default:
                cookiePolicyContainer.addClass("is--active");
                break
        }

        acceptCookies.on("click", function (e) {
            e.preventDefault();
            cookiePolicyContainer.addClass("is--confirmed").removeClass("is--active");
            CookiesManager.setCookieValue("cookiesPolicyAccepted", "isAccepted", 7);
        });

        $('#cookiesDisagree, #cookiesAgree').on('click', function(){
            $('#cookiesModalAgree').removeAttr('disabled');
        });

        $('#cookiesModalAgree').on('click', function () {
            if($('#cookiesDisagree').is(":checked")){
                cookiePolicyContainer.addClass("is--confirmed").removeClass("is--active");
                CookiesManager.setCookieValue("cookiesPolicyAccepted", "isNotAccepted", 7);
            }
            if($('#cookiesAgree').is(":checked")){
                cookiePolicyContainer.addClass("is--confirmed").removeClass("is--active");
                CookiesManager.setCookieValue("cookiesPolicyAccepted", "isAccepted", 7);
            }
            $('#cookiesModal').modal('hide');
        });
    })
}(window));